import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1f6b5e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["transform"]
const _hoisted_2 = ["width", "height"]
const _hoisted_3 = ["x1", "x2", "y2"]
const _hoisted_4 = ["x2", "y1", "y2"]

import { computed } from 'vue';

interface Props {
  trans: string;
  w: number;
  h: number;
  sq: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MillRect',
  props: {
    trans: null,
    w: { default: 1 },
    h: { default: 1 },
    sq: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { trans: string, w: number, h: number, sq: boolean };



const trans = computed( () => props.trans );
const w = computed( () => props.w );
const h = computed( () => props.h );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("g", {
    class: "millrect",
    transform: _unref(trans)
  }, [
    _createElementVNode("rect", {
      class: _normalizeClass(__props.sq ? 'sq' : 'rect'),
      x: "0",
      y: "0",
      width: _unref(w),
      height: _unref(h)
    }, null, 10, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(w)-1), (x) => {
      return (_openBlock(), _createElementBlock("line", {
        key: 'vert-' + x,
        class: _normalizeClass(__props.sq ? 'sqMesh' : 'rectMesh'),
        x1: x,
        x2: x,
        y1: "0",
        y2: _unref(h)
      }, null, 10, _hoisted_3))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_unref(h)-1), (y) => {
      return (_openBlock(), _createElementBlock("line", {
        key: 'hori-' + y,
        class: _normalizeClass(__props.sq ? 'sqMesh' : 'rectMesh'),
        x1: "0",
        x2: _unref(w),
        y1: y,
        y2: y
      }, null, 10, _hoisted_4))
    }), 128))
  ], 8, _hoisted_1))
}
}

})